import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';


@Component({
  selector: 'app-register-user',
  templateUrl: './register-user.component.html',
  styleUrls: ['./register-user.component.scss'],
})
export class RegisterUserComponent implements OnInit {
  @Input() modalStatus = {open: true, close: false};
  @Input() error;
  @Output() onSignUpRegis= new EventEmitter();
  message = '';
  SignUp = {open: false};


  ngOnChanges(): void {
    this.message = this.error && this.error.message ? this.error.message : this.error ? this.error : '';
  }

  openSignUpForm() {
   this.modalStatus = {open: false, close: true}
   this.onSignUpRegis.emit(true)
  }

  Close() {
    this.modalStatus = {open: false, close: true}
  }

  ngOnInit(): void {
  }
}
